<template>
  <b-container>
    <b-row>
      <b-col>
        <h6 class="subtitle">Trainers</h6>
        <team-trainer></team-trainer>
      </b-col>
      <b-col>
        <h6 class="subtitle">Trainers currently in the Team</h6>
        <b-form-group>
          <div v-if="trainerTable.length">
            <b-col>
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    v-model="filteredResults"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-btn
                      :disabled="!filteredResults"
                      @click="filteredResults = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-table
              v-cloak
              responsive
              :fields="teamTrainerFields"
              :items="trainerTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filteredResults"
              @filtered="filteredTrainers"
            >
              <template slot="cell(trainer_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{ name: 'EditTrainer', params: { id: row.item.uuid } }"
                  >{{ row.item.name }}</b-link
                >
                <br />
              </template>
              <template slot="cell(id)" slot-scope="row">
                <b-link class="delete" @click.stop="removeTrainer(row.index)"
                  >DELETE</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="trainerTable.length || 0"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import TeamTrainer from "./TeamTrainersList";

export default {
  name: "TeamTrainers",
  components: {
    TeamTrainer,
  },
  data() {
    return {
      teamTrainerFields: [
        { key: "trainer_name", label: "name", sortable: true },
        { key: "id", label: "REMOVE TRAINER" },
      ],
      currentPage: 1,
      perPage: 5,
      filteredResults: null,
    };
  },
  methods: {
    ...mapActions({
      DELETE_TRAINER: "teams/DELETE_TRAINER",
      GET_TEAM_TRAINERS: "teams/GET_TEAM_TRAINERS",
    }),
    async removeTrainer(index) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this trainer from this group?"
      );
      if (confirmDelete) {
        const trainersIds = [...this.$store.state.teams.team.trainers];
        const trainersNames = [...this.$store.state.teams.team.trainer_names];

        if (!this.add) await this.DELETE_TRAINER({ id: trainersIds[index] });

        trainersIds.splice(index, 1);
        trainersNames.splice(index, 1);
        this.$store.commit("teams/trainers", trainersIds);
        this.$store.commit("teams/trainer_names", trainersNames);

        const results = [];
        // eslint-disable-next-line
        for (let i = 0; i < trainersIds.length; i++) {
          const obj = { id: trainersIds[i], trainer_name: trainersNames[i] };
          results.push(obj);
        }

        if (!this.add) await this.GET_TEAM_TRAINERS();
      }
    },
    stopClick() {},
    filteredTrainers(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  computed: {
    ...mapGetters({
      trainers: "teams/teamTrainersObj",
    }),
    add() {
      return this.$route.path.includes("/add") ? true : false;
    },
    teamTrainers: {
      get() {
        return this.$store.state.teams.teamTrainers;
      },
    },
    teamTrainersNames: {
      get() {
        return this.$store.state.teams.team.trainer_names;
      },
    },
    teamTrainersIds: {
      get() {
        return this.$store.state.teams.team.trainers;
      },
    },
    trainerTable() {
      if (!this.add) {
        console.log(this.teamTrainers);
        const trainers = this.teamTrainers.map((k) => ({
          id: k.id,
          uuid: k.uuid,
          name: `${k.first_name} ${k.last_name}`,
          active: k.active,
        }));
        return trainers;
      } else {
        console.log("teamTrainersNames: ", this.teamTrainersNames);
        const ids = this.teamTrainersIds;
        const trainers = this.teamTrainersNames.map(function(obj, index) {
          return {
            id: null,
            uuid: ids[index],
            name: obj,
            active: true,
          };
        });
        return trainers;
      }
    },
  },
  watch: {
    trainers(val) {
      console.log("val: ", val);
    },
  },
  created() {
    this.GET_TEAM_TRAINERS();
  },
};
</script>
